import _defineProperty2 from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _slicedToArray from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import './index.css';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React, { PureComponent } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import Loader from '@clearscore/ui.rainbow.loader';
import Text from '@clearscore/ui.rainbow.text';
import toTitleCase from '@clearscore-group/lib.normalize.title-case';
var types = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY',
  TERTIARY: 'TERTIARY',
  STICKY: 'STICKY'
};
var sizes = {
  TINY: 'TINY',
  SMALL: 'SMALL',
  LARGE: 'LARGE'
};
var themes = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  INHERIT: 'INHERIT'
};
var styles = {
  "button": "button--ekzRQ",
  "isTypePrimary": "isTypePrimary--lau1U",
  "isThemeLight": "isThemeLight--lDw0V",
  "isFlat": "isFlat--nh1T2",
  "isDisabled": "isDisabled--Ldeuw",
  "isThemeDark": "isThemeDark--8TIX6",
  "isThemeInherit": "isThemeInherit--HOaP6",
  "isTypeSecondary": "isTypeSecondary--8ia9e",
  "isTypeTertiary": "isTypeTertiary--R900p",
  "isTypeSticky": "isTypeSticky--LbeJ9",
  "isSizeTiny": "isSizeTiny--ip-yD",
  "isSizeSmall": "isSizeSmall--ElXC4",
  "isSizeLarge": "isSizeLarge--hcT-z",
  "isWide": "isWide--vMcLD",
  "isNarrow": "isNarrow--uaSQx",
  "isResponsive": "isResponsive--dJeb-",
  "loaderWrapper": "loaderWrapper--xPNY4",
  "loader": "loader--5JQv7"
};
var _excluded = ["type", "size", "theme", "isWide", "isNarrow", "isFlat", "isResponsive", "isDisabled", "href", "dataId", "htmlType", "newTab", "routerTrackingSource", "routerTrackingProps", "state", "download", "loadingLabel"];
var getReactRouterLinkToProps = function getReactRouterLinkToProps(href) {
  if (href) {
    var _href$split = href.split('#'),
      _href$split2 = _slicedToArray(_href$split, 2),
      hashPathname = _href$split2[0],
      hash = _href$split2[1];
    var _hashPathname$split = hashPathname.split('?'),
      _hashPathname$split2 = _slicedToArray(_hashPathname$split, 2),
      pathname = _hashPathname$split2[0],
      search = _hashPathname$split2[1];
    return {
      pathname: pathname,
      hash: hash,
      search: search
    };
  }
  return {
    pathname: '',
    hash: '',
    search: ''
  };
};
var Button = /*#__PURE__*/function (_PureComponent) {
  _inherits(Button, _PureComponent);
  var _super = _createSuper(Button);
  function Button() {
    var _this;
    _classCallCheck(this, Button);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var onClick = _this.props.onClick;
      if (!_this.isDisabled && onClick) {
        onClick(event);
      }
    });
    return _this;
  }
  _createClass(Button, [{
    key: "isDisabled",
    get: function get() {
      var _this$props2 = this.props,
        isDisabled = _this$props2.isDisabled,
        isLoading = _this$props2.isLoading;
      return (isDisabled || isLoading) === true;
    }
  }, {
    key: "target",
    get: function get() {
      var _this$props3 = this.props,
        href = _this$props3.href,
        newTab = _this$props3.newTab;
      if (!href) {
        return undefined;
      }
      return newTab ? '_blank' : '_self';
    }
  }, {
    key: "ButtonText",
    get: function get() {
      var _this$props4 = this.props,
        isLoading = _this$props4.isLoading,
        size = _this$props4.size,
        children = _this$props4.children,
        loadingLabel = _this$props4.loadingLabel;
      var sizeClass = styles["isSize".concat(toTitleCase(size))];
      var loaderClass = cx(styles.loaderWrapper, sizeClass);
      var TextButton = size === sizes.LARGE ? Text.Button1 : Text.Button2;
      return /*#__PURE__*/React.createElement(TextButton, null, isLoading ? /*#__PURE__*/React.createElement("div", {
        className: loaderClass
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.loader
      }, /*#__PURE__*/React.createElement(Loader, {
        size: Loader.Size[size]
      }, loadingLabel)), "\xA0") : children);
    }
  }, {
    key: "render",
    value: function render() {
      var _cx;
      var _this$props = this.props,
        type = _this$props.type,
        size = _this$props.size,
        theme = _this$props.theme,
        isWide = _this$props.isWide,
        isNarrow = _this$props.isNarrow,
        isFlat = _this$props.isFlat,
        isResponsive = _this$props.isResponsive,
        isDisabled = _this$props.isDisabled,
        href = _this$props.href,
        dataId = _this$props.dataId,
        htmlType = _this$props.htmlType,
        newTab = _this$props.newTab,
        routerTrackingSource = _this$props.routerTrackingSource,
        routerTrackingProps = _this$props.routerTrackingProps,
        state = _this$props.state,
        download = _this$props.download,
        loadingLabel = _this$props.loadingLabel,
        props = _objectWithoutProperties(_this$props, _excluded);
      var typeClass = styles["isType".concat(toTitleCase(type))];
      var sizeClass = styles["isSize".concat(toTitleCase(size))];
      var themeClass = styles["isTheme".concat(toTitleCase(theme))];
      var CustomTag = href ? 'a' : 'button';
      var buttonProps = _objectSpread(_objectSpread({}, props), {}, {
        className: cx(styles.button, typeClass, sizeClass, themeClass, (_cx = {}, _defineProperty2(_cx, styles.isWide, isWide), _defineProperty2(_cx, styles.isNarrow, isNarrow), _defineProperty2(_cx, styles.isFlat, isFlat), _defineProperty2(_cx, styles.isDisabled, isDisabled), _defineProperty2(_cx, styles.isResponsive, isResponsive), _cx)),
        disabled: this.isDisabled,
        onClick: this.handleClick
      });
      /**
       * We need to remove incompatible HTML attributes,
       * from our button/anchor/link.
       */
      delete buttonProps.isLoading;
      var isInternalLink = (!newTab && href && !href.startsWith('http')) === true;
      if (isInternalLink && href) {
        /**
         * Checks the route and updates the UI without reloading the full page in the browser.
         */
        var getToPropValues = function getToPropValues() {
          var toProps = getReactRouterLinkToProps(href);
          if (state && (routerTrackingSource || routerTrackingProps)) {
            return _objectSpread(_objectSpread({}, toProps), {}, {
              state: _objectSpread(_objectSpread({}, state), {}, {
                tracking: {
                  source: routerTrackingSource,
                  props: routerTrackingProps
                }
              })
            });
          }
          if (state) {
            return _objectSpread(_objectSpread({}, toProps), {}, {
              state: state
            });
          }
          return _objectSpread(_objectSpread({}, toProps), {}, {
            state: {
              tracking: {
                source: routerTrackingSource,
                props: routerTrackingProps
              }
            }
          });
        };
        var hasState = state || routerTrackingSource || routerTrackingProps;
        var to = hasState ? getToPropValues() : href;
        return /*#__PURE__*/React.createElement(Link, _objectSpread(_objectSpread({}, buttonProps), {}, {
          "data-id": dataId,
          "data-qa": "button",
          to: to
        }), this.ButtonText);
      }
      return /*#__PURE__*/React.createElement(CustomTag, _objectSpread(_objectSpread({}, buttonProps), {}, {
        href: href || undefined,
        type: href ? undefined : htmlType,
        target: this.target,
        rel: this.target && 'noopener noreferrer',
        "data-qa": "button",
        "data-id": dataId,
        download: download
      }), this.ButtonText);
    }
  }]);
  return Button;
}(PureComponent); // eslint-disable-next-line react/static-property-placement
_defineProperty(Button, "defaultProps", {
  type: types.PRIMARY,
  size: sizes.SMALL,
  theme: themes.LIGHT,
  isWide: false,
  isNarrow: false,
  isFlat: false,
  isResponsive: false,
  isDisabled: false,
  isLoading: false,
  loadingLabel: 'loading',
  onClick: undefined,
  href: undefined,
  newTab: false,
  htmlType: 'button',
  dataId: undefined,
  routerTrackingSource: undefined,
  routerTrackingProps: undefined,
  state: undefined,
  download: false
});
_defineProperty(Button, "types", types);
_defineProperty(Button, "sizes", sizes);
_defineProperty(Button, "themes", themes);
export default Button;